var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "block-editor holiday-plus-hotels" }, [
    _c(
      "div",
      { staticClass: "editor-row" },
      [
        _c("div", { staticClass: "editor-row-title" }, [
          _vm._v(_vm._s(_vm.$t("chatbotv2.holidayAdultCount"))),
        ]),
        _vm._v(" "),
        _c("TiptapEditor", {
          attrs: {
            placeholder: _vm.$t("chatbotv2.holidayAdultCount"),
            "show-attributes": true,
            "max-character-count": 500,
          },
          model: {
            value: _vm.clone.adultCount,
            callback: function ($$v) {
              _vm.$set(_vm.clone, "adultCount", $$v)
            },
            expression: "clone.adultCount",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "editor-row" },
      [
        _c("div", { staticClass: "editor-row-title" }, [
          _vm._v(_vm._s(_vm.$t("chatbotv2.holidayChildCount"))),
        ]),
        _vm._v(" "),
        _c("TiptapEditor", {
          attrs: {
            placeholder: _vm.$t("chatbotv2.holidayChildCount"),
            "show-attributes": true,
            "max-character-count": 500,
          },
          model: {
            value: _vm.clone.childCount,
            callback: function ($$v) {
              _vm.$set(_vm.clone, "childCount", $$v)
            },
            expression: "clone.childCount",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "editor-row" },
      [
        _c("div", { staticClass: "editor-row-title" }, [
          _vm._v(_vm._s(_vm.$t("chatbotv2.holidayCheckIn"))),
        ]),
        _vm._v(" "),
        _c("TiptapEditor", {
          attrs: {
            placeholder: _vm.$t("chatbotv2.holidayCheckIn"),
            "show-attributes": true,
            "max-character-count": 500,
          },
          model: {
            value: _vm.clone.checkIn,
            callback: function ($$v) {
              _vm.$set(_vm.clone, "checkIn", $$v)
            },
            expression: "clone.checkIn",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "editor-row" },
      [
        _c("div", { staticClass: "editor-row-title" }, [
          _vm._v(_vm._s(_vm.$t("chatbotv2.holidayCheckOut"))),
        ]),
        _vm._v(" "),
        _c("TiptapEditor", {
          attrs: {
            placeholder: _vm.$t("chatbotv2.holidayCheckOut"),
            "show-attributes": true,
            "max-character-count": 500,
          },
          model: {
            value: _vm.clone.checkOut,
            callback: function ($$v) {
              _vm.$set(_vm.clone, "checkOut", $$v)
            },
            expression: "clone.checkOut",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "editor-row" },
      [
        _c("div", { staticClass: "editor-row-title" }, [
          _vm._v(_vm._s(_vm.$t("chatbotv2.holidayChildrenAges"))),
        ]),
        _vm._v(" "),
        _c("TiptapEditor", {
          attrs: {
            placeholder: _vm.$t("chatbotv2.holidayChildBirthdaysPh"),
            "show-attributes": true,
            "max-character-count": 500,
          },
          model: {
            value: _vm.clone.childrenAges,
            callback: function ($$v) {
              _vm.$set(_vm.clone, "childrenAges", $$v)
            },
            expression: "clone.childrenAges",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "inputTitle mt-1 mb-2 font-weight-bold" }, [
      _vm._v(_vm._s(_vm.$t("chatbotv2.followingAttributesFilled"))),
    ]),
    _vm._v(" "),
    _c(
      "section",
      { staticClass: "next-step-filled-items-wrapper" },
      _vm._l(_vm.nextStepFilledValue, function (attr) {
        return _c(
          "div",
          { key: attr, staticClass: "logos middle-section" },
          [
            _c("AttributeIconPreview", { attrs: { attribute: attr } }),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "ml-2" },
              [_c("AttributeLabel", { attrs: { attribute: attr } })],
              1
            ),
          ],
          1
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }